import React, { useState, useEffect } from "react";
import { Modal, Table, Input } from "antd";
import "./Avisos.css";

const Avisos = ({ visible, onClose }) => {
  const [eternity, setEternity] = useState([]);
  const [namelesss, setNamelesss] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const guilds = ["Eternity", "Namelesss"];
      for (const guild of guilds) {
        try {
          const res = await fetch(`https://api.tibiadata.com/v4/guild/${guild}`);
          const data = await res.json();
          const players = data.guild.members
            .filter(member => {
              const joinedDate = new Date(member.joined);
              const tenDaysAgo = new Date();
              tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
              return joinedDate >= tenDaysAgo;
            })
            .map(member => ({
              key: member.name,
              name: member.name,
              vocation: member.vocation,
              level: member.level,
              joined: new Date(member.joined).toISOString().split("T")[0],
            }));

          guild === "Eternity" ? setEternity(players) : setNamelesss(players);
        } catch (error) {
          console.error(`Erro ao buscar dados de ${guild}:`, error);
        }
      }
      setLoading(false);
    };

    if (visible) {
      fetchData();
    }
  }, [visible]);

  const getColumns = () => [
    {
      title: "Nombre",
      dataIndex: "name",
      width: '40%',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, _, index) => (
        <a
          href={`https://www.tibia.com/community/?name=${text}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>{text}</strong>
          {/* {index < 5 && <span className="last-icon">🆕</span>} */}
        </a>
      ),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Buscar nombre"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Vocacion",
      dataIndex: "vocation",
      width: '30%',
      sorter: (a, b) => a.vocation.localeCompare(b.vocation),
    },
    {
      title: "Level",
      dataIndex: "level",
      width: '15%',
      sorter: (a, b) => a.level - b.level,
    },
    {
      title: "Ingreso",
      dataIndex: "joined",
      width: '20%',
      sorter: (a, b) => new Date(a.joined) - new Date(b.joined),
      defaultSortOrder: 'descend', // ordem decrescente (mais recente no topo)
    },
  ];

  const renderGuildSection = (title, data) => (
    <div className="guild-box">
      <h2>{title}</h2>
      <p className="counter">
        <span className="count-number">{data.length}</span> jugadores ingresaron en los últimos 10 días
      </p>
      <div className="table-wrapper">
        <Table
          dataSource={data}
          columns={getColumns()}
          pagination={false}
          size="small"
          scroll={{ y: 300 }}
        />
      </div>
    </div>
  );

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title='Nuevos ingresos en guilds'
      width={900}
      centered
    >
      {loading ? (
        <div className="loading-box">
          <div className="spinner" />
          <p>Verificando nuevos jugadores en las guilds...</p>
        </div>
      ) : (
        <div className="guilds-wrapper">
          {renderGuildSection("Eternity", eternity)}
          {renderGuildSection("Namelesss", namelesss)}
        </div>
      )}
    </Modal>
  );
};

export default Avisos;